import React from "react";
import moment from "moment";

import { DateBlock } from "../blocks";

import { useEvents } from "../providers/content";


export const EventsPreview = () => {
  const upcomingEvents = useEvents({
    per_page: 5,
    start_date: moment().format(),
  });

  return (
    <>
    <h2>Veranstaltungen</h2>
      Folgende Termine haben wir für Sie zusammengestellt.
      {upcomingEvents && upcomingEvents.map((event, index) => <DateBlock key={index} event={event} className="border-dark" />)}
      <a href="/events" className="d-block text-uppercase text-success mt-4">
        Zum Veranstaltungskalender
      </a>
    </>
  );
}
